import { Routes } from "@angular/router";

export const SOFTLINE_PERMISSION_DASHBOARD = 'DASHBOARD';
